import Home from "./Home/Home";
import Service from "./Service/Service";
import Blog from "./Blog/Blog";
import Offer from "./Offer/Offer";
import NotFound from "./NotFound/NotFound";
import { isArray } from "core-js/fn/array";

const Routes = (titlePages: { id: string; title: string }[]) => {
  return isArray(titlePages)==true
    ? [
        {
          component: Service,
          path: "/service",
          title: titlePages?.find(id => id.id.match("services"))?.title || "مركز هدى للتزين النسائي",
        },
        {
          component: Blog,
          path: "/blog",
          title: titlePages?.find(id => id.id.match("blog"))?.title || "مركز هدى للتزين النسائي",
        },
        {
          component: Offer,
          path: "/offers",
          title: titlePages?.find(id => id.id.match("offers"))?.title || "مركز هدى للتزين النسائي",
        },
        {
          component: NotFound,
          path: "/404",
          title: titlePages?.find(id => id.id.match("404"))?.title || "مركز هدى للتزين النسائي",
      }, 
      {
        component: Home,
        path: "/",
        title: titlePages?.find(id => id.id.match("home"))?.title || "مركز هدى للتزين النسائي",
      }
      ]
    : [];
};

export default Routes;
